import { render, staticRenderFns } from "./VehicleDocumentInfo.vue?vue&type=template&id=09ec13e7&scoped=true&"
import script from "./VehicleDocumentInfo.vue?vue&type=script&setup=true&lang=js&"
export * from "./VehicleDocumentInfo.vue?vue&type=script&setup=true&lang=js&"
import style0 from "./VehicleDocumentInfo.vue?vue&type=style&index=0&id=09ec13e7&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09ec13e7",
  null
  
)

export default component.exports